module.exports = __webpack_public_path__ + "static/media/FantasyCoach_BG.53eaadb6.jpg";